module.exports = __webpack_public_path__ + "img/icon_bayer.21d53cdb.svg";